var HOT_PINK = "#FF69B4";
export var HIGH_VIS_FILTER;
(function(HIGH_VIS_FILTER) {
    HIGH_VIS_FILTER["TYPOGRAPHY"] = "typography";
    HIGH_VIS_FILTER["LAYOUT"] = "layout";
    HIGH_VIS_FILTER["COMPONENT"] = "component";
})(HIGH_VIS_FILTER || (HIGH_VIS_FILTER = {}));
export var highVisSlateComponent = function(elementType) {
    return function(param) {
        var theme = param.theme;
        var _theme_highVis;
        void theme;
        return ((_theme_highVis = theme.highVis) === null || _theme_highVis === void 0 ? void 0 : _theme_highVis[elementType]) ? "border: 1px solid ".concat(HOT_PINK, " !important;") : "";
    };
};
